import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Alert, Spinner } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getOrderIdByNumber } from '../../../services/requests/orders/orders-requests';

export function OrdersEditByNumber() {
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { search, hash } = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setError(null);
    const number = Number(orderNumber);
    if (!orderNumber || !/^\d+$/.test(orderNumber) || !Number.isInteger(number) || number <= 0 || number > 2147483647) {
      setError('Order number must be a positive integer.');
      return;
    }

    getOrderIdByNumber(number).then(id => {
      if (active) navigate({ pathname: `/orders/edit/${id}`, search, hash }, { replace: true });
    }).catch((cause: unknown) => {
      if (!active) return;
      setError(axios.isAxiosError(cause) && cause.response?.status === 404
        ? `Order number ${orderNumber} was not found.`
        : `Unable to open order number ${orderNumber}. Please try again.`);
    });

    return () => { active = false; };
  }, [orderNumber, search, hash, navigate]);

  return (
    <div className="p-3">
      {error
        ? <Alert variant="danger">{error} <Link to="/orders">Back to Orders</Link></Alert>
        : <Spinner animation="border" role="status"><span className="visually-hidden">Finding order...</span></Spinner>}
    </div>
  );
}
